import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

/** Illustration (or colored icon fallback) + title + subtitle shown when a task table has no rows. */
const TaskTableEmptyState = ({ icon: Icon, image, color, title, subtitle }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 5, gap: 0.75 }}>
    {image ? (
      <Box component="img" src={image} alt="" sx={{ width: 220, height: 220, objectFit: "contain", mb: 0.5 }} />
    ) : (
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: alpha(color, 0.12),
          mb: 0.75,
        }}
      >
        <Icon sx={{ fontSize: 28, color }} />
      </Box>
    )}
    <Typography sx={{ fontWeight: 700, fontSize: "1.15rem", color: "text.primary" }}>{title}</Typography>
    {subtitle && (
      <Typography sx={{ fontSize: "0.9rem", color: "text.secondary", textAlign: "center", maxWidth: 320 }}>
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default TaskTableEmptyState;
